import getEnvironment from './env';

interface nativeResult {
  code: number;
  msg: string;
  data: any;
}
const queue: Array<{
  method: string;
  params: Record<string, string>;
  callback: (resp: string) => void;
}> = [];

document.addEventListener('WebViewJavascriptBridgeReady', () => {
  queue.forEach(({ method, params, callback }) => {
    if (window.SuperAcme && typeof window.SuperAcme.call === 'function') {
      window.SuperAcme.call(method, params, callback);
    }
  });
  queue.length = 0; // 清空队列
});

export function bridgeCall(
  method: string,
  params: Record<string, any>,
  callback: (resp: string) => void,
) {
  if (window.SuperAcme && typeof window.SuperAcme.call === 'function') {
    console.log('bridgeCall============', method, params);
    window.SuperAcme.call(method, params, callback);
  } else {
    queue.push({ method, params, callback });
  }
}

/**
 * 把日志写入native
 * @param content 打印内容
 * @returns void
 */
export const log = (content: string) => {
  const { isSuperAcme } = getEnvironment();
  console.log(content);
  if (isSuperAcme) {
    bridgeCall('log', { content }, function () {});
  }
};

export function bridgeBootstrap(keyStr: string) {
  const { isSuperAcme, isIOS } = getEnvironment();

  function bootstrap(callback: () => void) {
    if (window.SuperAcme && typeof window.SuperAcme.call === 'function') {
      return callback();
    }

    if (window.WKWVJBCallbacks) {
      return window.WKWVJBCallbacks.push(callback);
    }

    window.WKWVJBCallbacks = [callback];
    if (window.webkit) {
      log(`postMessage__iOS_Native_InjectJavascript:${+new Date()}, host:${location.host}`);
      window.webkit.messageHandlers.iOS_Native_InjectJavascript.postMessage(null);
    }
  }

  if (isSuperAcme && isIOS) {
    bootstrap(() => {
      const ready = new CustomEvent('WebViewJavascriptBridgeReady', {
        detail: { platform: 'ios' },
      });
      document.dispatchEvent(ready);
      console.log('JavascriptBridge success=======', keyStr);
    });
  }
}

export const sendCacheDownloadResult = (result: boolean) => {
  const { isSuperAcme, isIOS } = getEnvironment();
  if (isSuperAcme) {
    if (isIOS) {
      window.webkit.messageHandlers?.cacheDownloadResult?.postMessage({
        result,
        host: location.host,
      });
    } else {
      bridgeCall('cacheDownloadResult', { result, host: location.host }, function () {});
    }
  }
};

// 跳转到某页
export const handleNavigateTo = (
  params: {
    type: string;
    url: string;
    context?: string;
    isImmersiveDisplay?: boolean;
    isNavBackItemHidden?: boolean;
  } = {
    type: '',
    url: '',
  },
) => {
  console.log('NavigateTo params============', params);
  try {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    window.SuperAcme &&
      window.SuperAcme.call('navigateTo', params, (res: any) => {
        console.log('res=========', res);
      });
  } catch (error) {
    console.log('error=====', error);
  }
};

// 返回堆顶。
export const handleNavigateBackRoot = () => {
  const { isIOS, isAndroid, isSuperAcme } = getEnvironment();
  if (isSuperAcme) {
    if (isIOS) {
      // 返回堆顶
      window.SuperAcme.call('popToRoot');
    } else if (isAndroid) {
      // 安卓会返回首页
      handleNavigateTo({
        type: 'app',
        url: 'cinmoore://main.com/main/activity',
      });
    }
  }
};
// 调用系统截图并且调用分享
export const screenshotAndShare = () => {
  return new Promise((resolve) => {
    bridgeCall('screenshotAndShare', {}, function (result: any) {
      resolve(JSON.parse(result));
    });
  });
};

export const getCapabilityByNative: (deviceId: string) => Promise<nativeResult> = (
  deviceId: string,
) => {
  return new Promise((resolve) => {
    bridgeCall('getDeviceCapability', { deviceId }, function (result: any) {
      resolve(JSON.parse(result));
    });
  });
};

// 打开三方分享
// {
//   shareType: 0, //0：默认图文 1：纯文字，2：纯图片，3：音乐，4：视频 必填
//   title: '标题',// 0、1必填
//   summary: '摘要', // 非必填
//   imagePath: 'xxx/xxx/xxx/share.jpg', // 分享图片/缩略图的本地地址 0、2必填
//   targetUrl: 'http://www.example.com', // 点击后的跳转 URL 非必填
//   platforms: 'WeChat' // 分享的平台: WeChat(微信好友)、WeChatCircle(微信朋友圈) 必填
//   params: {
//     key: 'value'
//   } // 分享的参数 非必填
// }
export const openThirdShare = ({
  title,
  imagePath,
  targetUrl,
  platforms,
  shareType,
  params,
}: {
  title: string;
  imagePath: string;
  targetUrl: string;
  platforms: string;
  shareType: number;
  params: Record<string, any>;
}) => {
  return new Promise((resolve) => {
    bridgeCall(
      'openThirdShare',
      { shareType, title, imagePath, targetUrl, platforms, params },
      function (result: any) {
        resolve(JSON.parse(result));
      },
    );
  });
};

// toast bridge
interface IToast {
  type: 'success' | 'error' | 'info' | 'warning' | 'loading';
  content: string;
  duration?: string;
  position?: 'top' | 'center' | 'bottom';
}

export const Toast = ({ type, content = '', duration, position }: IToast) => {
  const { isIOS } = getEnvironment();
  if (window.SuperAcme) {
    bridgeCall(
      'toast',
      {
        type,
        content,
        duration: duration ? duration : isIOS ? '2' : '0',
        position,
      },
      () => {},
    );
  } else {
    // message.success(content);
    console.log({ type, content });
  }
};
